import { render, staticRenderFns } from "./SystemPreferences.vue?vue&type=template&id=76e069f8&scoped=true&"
import script from "./SystemPreferences.vue?vue&type=script&lang=js&"
export * from "./SystemPreferences.vue?vue&type=script&lang=js&"
import style0 from "./SystemPreferences.vue?vue&type=style&index=0&id=76e069f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e069f8",
  null
  
)

export default component.exports